import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'

export interface UnreadMessageUser {
  user_id: string
  user_email: string
  user_name: string | null
  unread_count: number
  last_message_date: string
}

export interface MessageAnalytics {
  total_unread: number
  users_with_unread: UnreadMessageUser[]
}

export const messageAnalyticsQueryKey = ['dashboard-message-analytics']

export function useMessageAnalytics() {
  async function getAnalytics(): Promise<MessageAnalytics> {
    const response = await apiClient.get<MessageAnalytics>(
      SNA_PREFIX + 'dashboard/message-analytics'
    )
    return response.data
  }

  return useQuery({
    queryFn: getAnalytics,
    queryKey: messageAnalyticsQueryKey
  })
}
